<template lang="pug">
  div.text-align-right
    v-select(
      hide-details,
      single-line,
      prepend-icon="fas fa-align-left",
      :items="[10, 25, 50]",
      :value="value",
      @input="$emit('update:value', $event)",
    )
</template>

<script>
export default {
  props: {
    value: {
      validator: prop =>
        ['string', 'number', 'object', 'undefined'].includes(typeof prop),
      required: true,
    },
  },
};
</script>
